function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import keyBy from "lodash/keyBy";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
import { Placement } from "common/components/tooltip/types";
import { RevealableTextEditEl } from "common/components/revealable-text-editor";
import { InputSize } from "common/components/input/types";
import { ButtonEl } from "common/components/button";
import { Directions } from "common/components/drop-menu/types";
import { SIZE, TEXT_HIGHLIGHT_THEME, TextHighlightEl } from "common/components/text-highlight";
import { ButtonTheme } from "common/components/button/constants";
import { DropMenuEl } from "common/components/drop-menu";
import { IconSizeType, PATH_SEPARATOR } from "common/constants";
import { Visibility, VisibilityEvents } from "common/components/base/stackable";
import { SelectEl } from "common/components/select";
import { SelectTheme } from "common/components/select/constants";
import { UserIconEl } from "common/widgets/user-icon";
import { UserListEl } from "common/widgets/user-list";
import { getBrowseUrl } from "common/report/util/search";
import { formatDate, parseDate } from "common/util/date";
import { DetailType } from "./types";
import { trackDiscoverBackLinkClicked } from "./util";
const MAX_DESCRIPTION_DISPLAY_LENGTH = 400;
var DEFAULT_ICON = /* @__PURE__ */ ((DEFAULT_ICON2) => {
  DEFAULT_ICON2["PERSON"] = "person";
  DEFAULT_ICON2["FIRE"] = "fire";
  DEFAULT_ICON2["PIE"] = "pie";
  DEFAULT_ICON2["PULSE"] = "pulse";
  return DEFAULT_ICON2;
})(DEFAULT_ICON || {});
const defaultMetrics = {
  person: {
    icon: "person" /* PERSON */,
    tooltip: (_ref) => {
      let {
        t
      } = _ref;
      return t("query-builder.context-menu.no-data");
    },
    value: "-",
    rank: null,
    rankToolTip: ""
  },
  fire: {
    icon: "fire" /* FIRE */,
    tooltip: (_ref2) => {
      let {
        t
      } = _ref2;
      return t("query-builder.context-menu.no-data");
    },
    value: "-",
    rank: null,
    rankToolTip: ""
  },
  pie: {
    icon: "pie" /* PIE */,
    tooltip: (_ref3) => {
      let {
        t
      } = _ref3;
      return t("query-builder.context-menu.no-data");
    },
    value: "-",
    rank: null,
    rankToolTip: ""
  },
  pulse: {
    icon: "pulse" /* PULSE */,
    tooltip: (_ref4) => {
      let {
        t
      } = _ref4;
      return t("query-builder.context-menu.no-data");
    },
    value: "-",
    rank: null,
    rankToolTip: ""
  }
};
export function template() {
  if (!this.helpers.isTooltipDataSet()) {
    return /* @__PURE__ */ jsx("div", { style: {
      display: "none"
    } });
  }
  const {
    description
  } = this.state;
  const {
    backgroundColor,
    header,
    subHeader,
    path,
    entityIcon,
    showNewForFreeUsers,
    editItem,
    isUnsaved,
    isRecentlyUsed,
    definitionDetails,
    definitionRenderer,
    details: rowDetails,
    metrics: measuredMetrics,
    excludedMetricIcons,
    extraInfo,
    hideMetricsSection,
    queriedByUsers,
    noteForFreeUsers,
    tags,
    imageInfo,
    verified,
    verifiedAt,
    verifiedBy
  } = this.params.data;
  const {
    t,
    print
  } = this.getContext("i18n");
  const projectIsFreePlan = this.attr("project-is-free-plan");
  const HeaderEl = () => {
    return /* @__PURE__ */ jsx("div", { sel: ".header", "data-sentry-component": "HeaderEl", "data-sentry-source-file": "template.tsx" }, entityIcon ? /* @__PURE__ */ jsx("div", { sel: ".header-icon" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
      icon: entityIcon
    } })) : null, /* @__PURE__ */ jsx("div", { sel: ".header-text" }, /* @__PURE__ */ jsx("div", { sel: ".heading", class: {
      "is-unsaved": isUnsaved
    } }, (path === null || path === void 0 ? void 0 : path.length) > 0 && /* @__PURE__ */ jsx("span", { sel: ".path" }, [...path, ""].map((step) => print(step)).join(PATH_SEPARATOR)), /* @__PURE__ */ jsx("span", { sel: ".leaf" }, print(header), isUnsaved ? "*" : null)), subHeader ? /* @__PURE__ */ jsx("div", { sel: ".subheader" }, /* @__PURE__ */ jsx("div", { sel: ".text" }, print(subHeader))) : null), showNewForFreeUsers && projectIsFreePlan && /* @__PURE__ */ jsx("div", { sel: ".header-show-new-for-free-users" }, /* @__PURE__ */ jsx(TextHighlightEl, { attrs: {
      text: t("query-builder.context-menu.new"),
      theme: TEXT_HIGHLIGHT_THEME.INFORMATION
    } })));
  };
  const DefinitionDetailSectionEl = (_ref5) => {
    let {
      details
    } = _ref5;
    if (!details) {
      return null;
    }
    return /* @__PURE__ */ jsx("div", { sel: ".definition-detail-section", "data-sentry-component": "DefinitionDetailSectionEl", "data-sentry-source-file": "template.tsx" }, details.map((detail) => /* @__PURE__ */ jsx("div", { sel: ".detail" }, /* @__PURE__ */ jsx("div", { sel: ".detail-name" }, print(detail.name)), /* @__PURE__ */ jsx("div", { sel: ".detail-value" }, detail.value))));
  };
  const RowDetailSectionEl = (_ref6) => {
    let {
      details
    } = _ref6;
    if (!details) {
      return null;
    }
    return /* @__PURE__ */ jsx("div", { sel: ".row-detail-section", "data-sentry-component": "RowDetailSectionEl", "data-sentry-source-file": "template.tsx" }, details === null || details === void 0 ? void 0 : details.map((detail) => {
      var _detail$value, _detail$value2, _detail$value4;
      return /* @__PURE__ */ jsx("div", { sel: ".detail" }, /* @__PURE__ */ jsx("div", { sel: ".detail-name" }, print(detail.name)), /* @__PURE__ */ jsx("div", { sel: ".detail-value" }, detail.type === DetailType.User ? /* @__PURE__ */ jsx(UserIconEl, { sel: ".user-icon", attrs: _objectSpread({
        size: IconSizeType.XS,
        "include-label": true
      }, detail.value) }) : detail.type === DetailType.TextHighlight ? detail.value.map((item) => /* @__PURE__ */ jsx(TextHighlightEl, { attrs: {
        theme: TEXT_HIGHLIGHT_THEME.GENERIC,
        text: item,
        size: SIZE.SMALL
      } })) : detail.type === DetailType.BrowseLink ? /* @__PURE__ */ jsx("a", { sel: ".backlink", className: {
        disabled: ((_detail$value = detail.value) === null || _detail$value === void 0 ? void 0 : _detail$value.count) === 0
      }, attrs: {
        href: getBrowseUrl({
          queryParam: {
            "event-name-filter": (_detail$value2 = detail.value) === null || _detail$value2 === void 0 ? void 0 : _detail$value2.entityNameForBrowse
          },
          resetFilters: true
        })
      }, on: {
        click: () => {
          var _detail$value3;
          trackDiscoverBackLinkClicked({
            eventName: header,
            reportsCount: (_detail$value3 = detail.value) === null || _detail$value3 === void 0 ? void 0 : _detail$value3.count
          });
        }
      } }, t("query-builder.context-menu.report-backlinks", {
        count: +((_detail$value4 = detail.value) === null || _detail$value4 === void 0 ? void 0 : _detail$value4.count) || 0
      }), " \u2197") : detail.value));
    }));
  };
  const iconsToDisplay = ["pie" /* PIE */, "pulse" /* PULSE */];
  const metricDataByIcon = keyBy(measuredMetrics || [], "icon");
  const metrics = iconsToDisplay.map((icon) => metricDataByIcon[icon] || defaultMetrics[icon]).filter((metric) => !(excludedMetricIcons !== null && excludedMetricIcons !== void 0 && excludedMetricIcons.includes(metric.icon)));
  const FooterEl = () => /* @__PURE__ */ jsx("div", { sel: ".footer", "data-sentry-component": "FooterEl", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(null, null, verified && verifiedBy && /* @__PURE__ */ jsx("div", { sel: ".verify-icon-wrapper" }, /* @__PURE__ */ jsx(SvgIconEl, { sel: ".verify-icon", attrs: {
    icon: "verified-filled"
  } }), /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: Placement.Top
  } }, t("query-builder.context-menu.verified-tooltip", {
    date: formatDate(parseDate(verifiedAt, {
      iso: true
    })),
    name: verifiedBy
  }))), !hideMetricsSection ? /* @__PURE__ */ jsx("div", { sel: ".metrics-section" }, metrics === null || metrics === void 0 ? void 0 : metrics.map((metric) => /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".metric", class: {
    "empty-metric": metric.value === "-"
  } }, /* @__PURE__ */ jsx("div", { sel: ".metric-icon", class: {
    "small-metric-icon": metric.icon === "pie" /* PIE */
  } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: metric.icon
  } })), /* @__PURE__ */ jsx("div", { sel: ".metric-value" }, metric.value || "-"), /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: Placement.Top
  } }, print(metric.tooltip)), metric.rank ? /* @__PURE__ */ jsx("div", { sel: ".metric-rank" }, /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: Placement.Top
  } }, print(metric.rankToolTip)), /* @__PURE__ */ jsx(TextHighlightEl, { attrs: {
    theme: TEXT_HIGHLIGHT_THEME.INFORMATION,
    text: "# ".concat(metric.rank),
    size: SIZE.SMALL
  } })) : null)))) : null, queriedByUsers !== null && queriedByUsers !== void 0 && queriedByUsers.length ? /* @__PURE__ */ jsx("div", { sel: ".recently-queried-users" }, /* @__PURE__ */ jsx(UserListEl, { attrs: {
    size: IconSizeType.Small,
    "max-icons-displayed": 2,
    users: queriedByUsers
  } })) : null, this.helpers.getActionItems().length > 0 && /* @__PURE__ */ jsx("div", { sel: ".entity-actions" }, /* @__PURE__ */ jsx(SelectEl, { attrs: {
    icon: {
      leftIcon: "ellipsis"
    },
    "icon-only": true,
    "menu-width": 200,
    theme: SelectTheme.Tertiary,
    "menu-alignment": Directions.Up,
    elref: "overflowMenu"
  }, class: {
    "row-actions": true
  }, props: {
    sections: [{
      items: this.helpers.getActionItems()
    }]
  }, on: {
    change: (ev) => this.helpers.handleActionClick(ev.detail.item)
  } }))));
  const footerText = projectIsFreePlan ? t(noteForFreeUsers) : "";
  const descriptionAddPlaceholder = "+ ".concat(t("query-builder.context-menu.description-add-placeholder"));
  const contextPanelContent = /* @__PURE__ */ jsx("div", { style: {
    borderRadius: "9px",
    backgroundColor
  }, on: {
    mouseenter: this.helpers.handleMouseEnter,
    mouseleave: this.helpers.handleMouseLeave
  } }, /* @__PURE__ */ jsx("div", { sel: ".root" }, /* @__PURE__ */ jsx("div", { sel: ".container" }, (() => {
    return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(HeaderEl, null), /* @__PURE__ */ jsx("div", { sel: ".content-body" }, isRecentlyUsed ? /* @__PURE__ */ jsx("div", { sel: ".recently-used" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
      icon: "time"
    } }), t("query-builder.context-menu.recently-used")) : null, tags !== null && tags !== void 0 && tags.length ? /* @__PURE__ */ jsx("div", { sel: ".tags" }, tags.map((tag) => /* @__PURE__ */ jsx(TextHighlightEl, { attrs: {
      theme: TEXT_HIGHLIGHT_THEME.GENERIC,
      text: tag
    } }))) : null, /* @__PURE__ */ jsx("div", { sel: ".description" }, description || editItem ? /* @__PURE__ */ jsx(RevealableTextEditEl, { attrs: {
      text: description,
      "hide-footer": true,
      "add-text-placeholder": descriptionAddPlaceholder,
      placeholder: t("query-builder.context-menu.description-placeholder"),
      "disable-edit": !editItem,
      size: InputSize.Medium
    }, on: {
      changedText: (ev) => this.helpers.handleTextEditorSave(ev, editItem)
    }, hook: {
      insert: this.helpers.editorInserted
    } }, (() => {
      return /* @__PURE__ */ jsx("div", { sel: ".description-content", attrs: {
        slot: "content"
      } }, editItem ? /* @__PURE__ */ jsx("div", { sel: ".description-text-wrapper" }, description ? this.helpers.formatText(description, {
        className: "description-text",
        maxLength: MAX_DESCRIPTION_DISPLAY_LENGTH
      }) : descriptionAddPlaceholder, /* @__PURE__ */ jsx("div", { sel: ".editable-icon" }, /* @__PURE__ */ jsx(ButtonEl, { sel: ".edit-description-button", attrs: {
        icon: "edit",
        theme: ButtonTheme.Tertiary
      } }))) : /* @__PURE__ */ jsx("div", { sel: ".description-text-wrapper" }, this.helpers.formatText(description, {
        className: "description-text",
        maxLength: MAX_DESCRIPTION_DISPLAY_LENGTH
      })));
    })()) : null), imageInfo && imageInfo.length ? /* @__PURE__ */ jsx("div", { sel: ".entity-media-section" }, imageInfo.map((info) => /* @__PURE__ */ jsx("div", { sel: ".entity-media" }, info.imageUrl ? /* @__PURE__ */ jsx("img", { sel: ".entity-image", attrs: {
      src: info.imageUrl
    } }) : null))) : null, /* @__PURE__ */ jsx(DefinitionDetailSectionEl, { details: definitionDetails }), definitionRenderer && /* @__PURE__ */ jsx("div", { sel: ".definition-section" }, definitionRenderer()), /* @__PURE__ */ jsx(RowDetailSectionEl, { details: rowDetails }), extraInfo && extraInfo.length ? /* @__PURE__ */ jsx("div", { sel: ".extra-info" }, extraInfo.map((info) => /* @__PURE__ */ jsx("div", { sel: ".info" }, /* @__PURE__ */ jsx("div", { sel: ".icon" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
      icon: "info"
    } })), /* @__PURE__ */ jsx("div", { sel: ".value" }, print(info))))) : null));
  })())), footerText && /* @__PURE__ */ jsx("div", { sel: ".footer-text" }, footerText), /* @__PURE__ */ jsx(FooterEl, null));
  return /* @__PURE__ */ jsx(DropMenuEl, { attrs: {
    open: Boolean(this.params.data),
    offset: this.attr("offset"),
    skidding: this.attr("skidding"),
    direction: this.attr("placement"),
    "position-strategy": this.attr("position-strategy"),
    "show-arrow": this.attr("show-arrow"),
    "allowed-flip-directions": this.attr("force-placement") && [this.attr("placement")],
    // when the context panel is opened, don't focus it as this will cause the associated menu's search input
    // to lose focus
    "disable-auto-focus": true
  }, props: {
    positionParent: this.params.positionParent
  }, on: {
    click: (ev) => {
      if (!(ev.target instanceof HTMLAnchorElement)) {
        ev.stopPropagation();
        ev.preventDefault();
      }
    }
    // No need to prevent mousedown event. Previously, it was opening up a menu
    // when context menu is clicked. Also, this allows text select within context panel.
  }, hook: {
    destroy: (vnode) => {
      const dropEl = vnode.elm;
      this.dispatchEvent(new CustomEvent(VisibilityEvents[Visibility.Closed], {
        bubbles: true,
        composed: true,
        detail: dropEl.getStackingDetail()
      }));
    }
  }, "data-sentry-element": "DropMenuEl", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, contextPanelContent);
}
